import { FC } from 'react';
import Grid from '@mui/material/Grid';
import usImg from '../../media/aboutus.png';
import { Paper, Typography, Button } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import useTranslations from '../global/translation/hooks/translation';
import React from 'react';
import Paragraphs from '../global/Paragraphs';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const About: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const text = translations.label.aboutUsText[currentLanguage];
  const paragraphs = text.split('\n\n');
  const theme = useTheme();
  const { darkMode } = useThemeContext();

  return (
    <Grid my={6} py={2} container justifyContent="center" alignItems="center" sx={{ bgcolor: darkMode ? '#121212' : '#fff' }}>
      <Grid item xs={12} m={2}>
        <Typography
          variant="h4"
          fontWeight={300}
          sx={{
            color: darkMode ? '#FFF' : '#000',
          }}
          textAlign="center"
        >
          {translations.menuItems.aboutUs[currentLanguage]}
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <div style={{ position: 'relative', paddingTop: '35%', margin: '16px' }}>
          <img style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }} src={usImg} alt="Carrousel Image" />
        </div>
        <div style={{ textAlign: 'center', margin: '16px' }}>
          <Button
            variant="outlined"
            color="primary"
            href="https://dziendobry.tvn.pl/styl-zycia/zwiazki-i-seks/barbara-urban-jimenzes-dzieki-pasji-odnalazla-prawdziwe-uczucie-st5741886"
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<PlayArrow />}
            sx={{
              borderColor: darkMode ? '#FFF' : theme.palette.primary.main,
              color: darkMode ? '#FFF' : theme.palette.primary.main,
              '&:hover': {
                borderColor: darkMode ? '#CCC' : theme.palette.primary.dark,
                backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
              },
            }}
          >
            {translations.buttons.watchTvnInterview[currentLanguage]}
          </Button>
        </div>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper elevation={12} sx={{ p: 2, m: 2, bgcolor: darkMode ? '#232323' : theme.palette.background.paper }}>
          <React.Fragment>
            <Paragraphs paragraphs={paragraphs} />
          </React.Fragment>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default About;
